import { render } from "./LateDeductionScheduleEditor.vue?vue&type=template&id=5628c01a&scoped=true"
import script from "./LateDeductionScheduleEditor.vue?vue&type=script&lang=js"
export * from "./LateDeductionScheduleEditor.vue?vue&type=script&lang=js"

import "./LateDeductionScheduleEditor.vue?vue&type=style&index=0&id=5628c01a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5628c01a"]])

export default __exports__